import { createSlice } from '@reduxjs/toolkit';

interface UserConfState {
  isSidebarOpen: boolean;
}

const initialState: UserConfState = {
  isSidebarOpen: false,
};

const userConfSlice = createSlice({
  name: 'userConf',
  initialState,
  reducers: {
    openSidebar: (state) => ({
      ...state,
      isSidebarOpen: true,
    }),
    closeSidebar: (state) => ({
      ...state,
      isSidebarOpen: false,
    }),
  },
});

export default userConfSlice;
